import { render, staticRenderFns } from "./datavant-tokenization-modal.vue?vue&type=template&id=bbd084fa&scoped=true&"
import script from "./datavant-tokenization-modal.vue?vue&type=script&lang=js&"
export * from "./datavant-tokenization-modal.vue?vue&type=script&lang=js&"
import style0 from "./datavant-tokenization-modal.vue?vue&type=style&index=0&id=bbd084fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd084fa",
  null
  
)

component.options.__file = "datavant-tokenization-modal.vue"
export default component.exports